import { Link, useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ChevronRight, Home } from "lucide-react";
import api from "@/lib/api";

// Breadcrumb dinamica basata su URL. Usa cache in-memory per evitare fetch ripetuti.
const cache = { groups: {}, cantieri: {}, righe: {} };

async function fetchGroup(id) {
  if (cache.groups[id]) return cache.groups[id];
  try { const { data } = await api.get(`/groups/${id}`); cache.groups[id] = data; return data; } catch { return null; }
}
async function fetchCantiere(id) {
  if (cache.cantieri[id]) return cache.cantieri[id];
  try { const { data } = await api.get(`/cantieri/${id}`); cache.cantieri[id] = data; return data; } catch { return null; }
}
async function fetchRiga(id) {
  if (cache.righe[id]) return cache.righe[id];
  try { const { data } = await api.get(`/righe/${id}`); cache.righe[id] = data; return data; } catch { return null; }
}

export default function Breadcrumb() {
  const location = useLocation();
  const params = useParams();
  const [crumbs, setCrumbs] = useState([]);

  useEffect(() => {
    (async () => {
      const parts = [{ label: "Home", to: "/", icon: Home }];
      const path = location.pathname;
      const seg = path.split("/").filter(Boolean);
      if (seg[0] === "g" && seg[1]) {
        const g = await fetchGroup(seg[1]);
        if (g) parts.push({ label: g.nome, to: `/g/${seg[1]}` });
        if (seg[2] === "cantieri") {
          if (seg[3]) {
            const c = await fetchCantiere(seg[3]);
            if (c) parts.push({ label: `${c.code} · ${c.nome}`, to: `/g/${seg[1]}/cantieri/${seg[3]}` });
            if (seg[4] === "righe" && seg[5]) {
              const r = await fetchRiga(seg[5]);
              if (r) {
                if (r.capitolo_nome) parts.push({ label: r.capitolo_nome, to: `/g/${seg[1]}/cantieri/${seg[3]}?tab=computo` });
                parts.push({ label: r.num_ord ? `N.Ord ${r.num_ord}` : "Voce", to: `/g/${seg[1]}/cantieri/${seg[3]}/righe/${seg[5]}` });
              }
            } else if (seg[4] === "import") {
              parts.push({ label: "Import XLSX", to: path });
            }
          } else {
            parts.push({ label: "Cantieri", to: `/g/${seg[1]}/cantieri` });
          }
        } else if (seg[2] === "ticket-tecnici") parts.push({ label: "Ticket tecnici", to: path });
        else if (seg[2] === "ticket-subappaltatori") parts.push({ label: "Ticket subappaltatori", to: path });
        else if (seg[2] === "calendario") parts.push({ label: "Calendario materiali", to: path });
        else if (seg[2] === "documenti") parts.push({ label: "Documenti", to: path });
        else if (seg[2] === "dashboard") parts.push({ label: "Dashboard", to: path });
      } else if (seg[0] === "admin") {
        if (seg[1] === "users") parts.push({ label: "Utenti & permessi", to: path });
        else if (seg[1] === "anagrafica") parts.push({ label: "Anagrafica persone", to: path });
      } else if (seg[0] === "change-password") {
        parts.push({ label: "Cambio password", to: path });
      }
      setCrumbs(parts);
    })();
  }, [location.pathname]);

  if (crumbs.length <= 1) return null;
  return (
    <nav aria-label="breadcrumb" data-testid="breadcrumb" className="text-xs text-slate-500 dark:text-slate-400 mb-3 flex flex-wrap items-center gap-1">
      {crumbs.map((c, i) => (
        <span key={`${c.to || "root"}-${c.label}`} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="h-3 w-3 text-slate-400" />}
          {i < crumbs.length - 1 ? (
            <Link to={c.to} className="hover:text-amber-600 transition-colors flex items-center gap-1">
              {c.icon && <c.icon className="h-3 w-3" />}
              <span className="truncate max-w-[180px]">{c.label}</span>
            </Link>
          ) : (
            <span className="text-slate-700 dark:text-slate-200 font-medium flex items-center gap-1">
              {c.icon && <c.icon className="h-3 w-3" />}
              <span className="truncate max-w-[240px]">{c.label}</span>
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}
